import React, { useImperativeHandle, useMemo, useState } from 'react'

import { CustomCellEditorProps } from 'ag-grid-react'

import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  MultiSelectCreate,
} from '@fortem-monorepo/react-ui'

import { TagsRendererComponent } from '@/ag-grid/columns/tags/renderer'

type EditorRef = {
  getValue: () => string[]
}

export interface TagCellEditorProps extends CustomCellEditorProps {}

export const createTagCellEditor = ({
  singularPhrase,
  pluralPhrase,
}: {
  singularPhrase?: string
  pluralPhrase?: string
}) => {
  return React.forwardRef<EditorRef, TagCellEditorProps>(
    ({ value, onValueChange, stopEditing }, ref) => {
      const [open, setOpen] = useState(true)
      const [innerValue, setInnerValue] = useState(value)

      useImperativeHandle(ref, () => ({
        getValue: () => innerValue,
      }))

      const items = useMemo(() => {
        // TODO: get the items from a reduce set over all data for the given field.
        // assumes the field is a comma separated value string
        return []
      }, [])

      if (innerValue && Array.isArray(innerValue)) {
        return (
          <>
            <TagsRendererComponent value={value} />
            <Dialog
              open={open}
              onOpenChange={(open) => {
                if (!open) {
                  stopEditing()
                }
                setOpen(open)
              }}
            >
              <DialogContent>
                <DialogHeader>
                  <DialogTitle>Update {pluralPhrase ?? 'tags'}</DialogTitle>
                  <DialogDescription></DialogDescription>
                </DialogHeader>
                <div>
                  <MultiSelectCreate
                    items={items}
                    singularPhrase={singularPhrase}
                    pluralPhrase={pluralPhrase}
                    value={innerValue}
                    onValueChange={(val) => {
                      setInnerValue(val)
                    }}
                  />
                </div>
                <DialogFooter>
                  <Button
                    variant={'destructive'}
                    onClick={() => {
                      setOpen(false)
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant={'default'}
                    onClick={() => {
                      onValueChange(innerValue)
                      stopEditing()
                    }}
                  >
                    Save
                  </Button>
                </DialogFooter>
              </DialogContent>
            </Dialog>
          </>
        )
      }
    },
  )
}
